/**
 * orga-app-api - veranstaltungen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RolleTitel { 
    titel: string;
    funktionsbereich_id: string;
    rolle_id: string;
    vorlage_rolle_id: string;
    veranstaltung_id: string;
    mandant_id?: string;
    modified_on_utc?: Date;
}

